module.exports = __webpack_public_path__ + "static/img/RAPS-1_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPS-1_1.png
// module id = aB1K
// module chunks = 0